export default "__VITE_ASSET__891009fe__"